var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('CustomNavBar',{attrs:{"title":_vm.$route.query.type === 'culture' ? '文旅线路' : '产业线路'}}),_c('div',{staticClass:"list"},[_c(_vm.$route.query.type,{key:_vm.$route.query.type,tag:"component",attrs:{"data":_vm.data}})],1),_c('img',{staticClass:"bg-img1",attrs:{"src":require('@/assets/bg01.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }